import mutations from "./mutations.js";
import actions from "./actions.js";
import getters from "./getters";

export default {
  namespaced: true,
  state: () => ({
    chat: [
      {
        continuation: false,
        message: "Hello! What would you like to learn today?",
        senderID: "AI",
        timestamp: new Date().toISOString(), // Set initial timestamp to ISO format
      },
    ],
    threadId: localStorage.getItem("threadId") || null,
    loading: false,
    unsubscribe: null,
    chatHistory: [],
    historyLoading: false,
  }),
  mutations,
  actions,
  getters,
};
